import React from 'react';
import TableComponent from './TableComponent'
import TableTabs from './TableTabs';

function DataGrid({ gridData, displaySettings, grid = false, reverseGrid = false }) {
  const freq_table = gridData.freq_table;
  const tabs = [];

  if (gridData?.Nets && gridData?.summaryNet) {
    freq_table.rows.filter(x => x.index <= -5555).forEach(stat => {
      tabs.push({
        key: `summary-${stat.index}`,
        label: stat.label ? `Summary - ${stat.label}` : `Table ${tabs.length + 1}`,
        content: (
          <React.Fragment key={stat.index}>
            <h1>{gridData.Qtitle} - Summary  {stat.label}</h1>
            <TableComponent cols={freq_table.cols} statements={freq_table.statements} datavalue={freq_table.datavalue}
              lvl1={"colIndex"} lvl2={"statementIndex"} lvl3={"rowIndex"} lvl4={"ratingIndex"}
              flt3={stat.index} flt4={0}
              displaySettings={displaySettings}
              summary={true}
            />
          </React.Fragment>
        )
      });
    });
  }

  if (freq_table && !gridData?.removeIndividual) {
    freq_table.statements.forEach(stat => {
      tabs.push({
        key: `statement-${stat.index}`,
        label: stat.label || `Table ${tabs.length + 1}`,
        content: (
          <React.Fragment key={stat.index}>
            <h1>{gridData.Qtitle} - {stat.label}</h1>
            <TableComponent cols={freq_table.cols} statements={freq_table.rows} datavalue={freq_table.datavalue}
              lvl1={"colIndex"} lvl2={"rowIndex"} lvl3={"statementIndex"} lvl4={"ratingIndex"}
              flt3={stat.index} flt4={0}
              displaySettings={displaySettings}
              szr={!!gridData.szr}
            />
          </React.Fragment>
        )
      });
    });
  }

  if (freq_table && grid) {
    tabs.push({
      key: 'grid-view',
      label: 'Grid View',
      content: (
        <React.Fragment key="grid-view">
          <h1>{gridData.Qtitle} - Grid View</h1>
          <TableComponent cols={freq_table.statements} statements={freq_table.rows} datavalue={freq_table.datavalue}
            lvl1={"statementIndex"} lvl2={"rowIndex"} lvl3={"colIndex"} lvl4={"ratingIndex"}
            flt3={0} flt4={0}
            displaySettings={displaySettings}
          />
        </React.Fragment>
      )
    });
  }

  if (freq_table && reverseGrid) {
    tabs.push({
      key: 'reverse-grid-view',
      label: 'Reverse Grid View',
      content: (
        <React.Fragment key="reverse-grid-view">
          <h1>{gridData.Qtitle} - Reverse Grid View</h1>
          <TableComponent cols={freq_table.rows} statements={freq_table.statements} datavalue={freq_table.datavalue}
            lvl1={"rowIndex"} lvl2={"statementIndex"} lvl3={"colIndex"} lvl4={"ratingIndex"}
            flt3={0} flt4={0}
            displaySettings={displaySettings}
          />
        </React.Fragment>
      )
    });
  }

  return (
    <div className="App">
      <TableTabs tabs={tabs} />
    </div>
  );
}

export default DataGrid;
